export function extractErrorMessage(error: unknown, defaultMessage: string): string {
	if (
		error &&
		typeof error === 'object' &&
		'response' in error &&
		error.response &&
		typeof error.response === 'object' &&
		'data' in error.response &&
		error.response.data &&
		typeof error.response.data === 'object' &&
		'message' in error.response.data
	) {
		return String(error.response.data.message);
	}
	return defaultMessage;
}
